import PropTypes from 'prop-types';

import { parseMCCategories } from '@/utils/paramsUtils';
import { Fragment } from 'react';
import MonteCarloRow from './MonteCarloRow';

const MonteCarloFields = ({ nodeId, params, caseParams }) => {
  const categories = parseMCCategories(params);
  const renderParamsByCategory = categoryName => {
    const paramsByCategory = categories[categoryName]?.params;

    return (
      <Fragment key={`category-${nodeId}-${categoryName}`}>
        <tr className="border-b border-ivory-100">
          <td colSpan={6} className="font-bold text-md py-2">
            {categoryName}
          </td>
        </tr>
        {renderParams(paramsByCategory)}
      </Fragment>
    );
  };

  const renderParams = params => {
    return params.map(paramSchema => {
      const { name, label } = paramSchema;
      const param = caseParams[name];

      return (
        param && (
          <MonteCarloRow
            nodeId={nodeId}
            key={`field-${nodeId}-${name}`}
            name={name}
            label={label}
            paramSchema={paramSchema}
            param={param}
          />
        )
      );
    });
  };

  return Object.values(categories).map(({ categoryName }) => renderParamsByCategory(categoryName));
};

MonteCarloFields.propTypes = {
  params: PropTypes.arrayOf(PropTypes.object),
  caseParams: PropTypes.object,
  nodeId: PropTypes.string,
};

export default MonteCarloFields;
